import React, { useState } from 'react';
import axios from 'axios';

const ModalCreateCallEat = ({ isVisible, onClose }) => {
    
    function generateRoom_id() {
        var length = 15,
            charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
            retVal = "";
        for (var i = 0, n = charset.length; i < length; ++i) {
            retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        return retVal;
    }

    const [values, setValues] = useState({
        nom_client: '',
        room_id:'',
        autorised:''
    })

    
    let token = localStorage.getItem("token");

    const headers = {
        'x-access-token': token,
        'Content-Type': 'application/json'
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let error = document.getElementById('error')
        error.innerHTML = '';
        if(values.nom_client === '' || values.autorised === ''){
            error.innerHTML = "Veuillez renseigner tout les champs"
        }else{
            
            values.room_id = generateRoom_id();
            console.log(values);
            axios.post(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/add_client_calleat`, values, { headers })
            .then(res => {
                // console.log(res);
                window.location.reload(false);
            }).catch(err => console.log(err))
        }
    }

    const handleClose = (e) => {
        if (e.target.id === "wrapper") onClose();
    }
    if (!isVisible) return null;
    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4' id="wrapper" onClick={handleClose}>
            <div className='bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[85vh] overflow-y-auto'>
                <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
                    <h2 className="text-lg font-semibold text-slate-800">Nouveau client CallEat</h2>
                    <button className='text-slate-400 hover:text-slate-600 text-xl leading-none' onClick={() => onClose()}>✕</button>
                </div>
                <form className="p-6" onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="nom_client" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Nom Client</label>
                        <input type="text" name="nom_client" id="nom_client" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder="Nom du client" required  onChange={e => setValues({...values, nom_client: e.target.value})}/>
                    </div>
                    <div className="mb-4">
                        <span className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Autorisé</span>
                        <div className="flex items-center gap-6">
                            <label className="inline-flex items-center gap-2 text-sm text-slate-700 hover:cursor-pointer" htmlFor="inlineCheckbox1">
                                <input
                                className="h-4 w-4 accent-indigo-500 hover:cursor-pointer"
                                type="radio"
                                id="inlineCheckbox1"
                                value="1"
                                onChange={e => setValues({...values, autorised: e.target.value})}
                                name="autorised"
                                />
                                Oui
                            </label>
                            <label className="inline-flex items-center gap-2 text-sm text-slate-700 hover:cursor-pointer" htmlFor="inlineCheckbox2">
                                <input
                                className="h-4 w-4 accent-indigo-500 hover:cursor-pointer"
                                type="radio"
                                id="inlineCheckbox2"
                                value="0"
                                onChange={e => setValues({...values, autorised: e.target.value})}
                                name="autorised"/>
                                Non
                            </label>
                        </div>
                    </div>

                    <button type="submit" className="w-full rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-600">Enregistrer</button>
                    <div className="py-4 text-center">
                        <p id="error" className='text-red-600'></p>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalCreateCallEat;